import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { supabase } from './supabase';
import { api } from './api';
const AuthContext = createContext({ user: null, loading: true });
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) { setUser(null); return; }
      setUser((await api.get('/auth/me')).data);
    } catch { setUser(null); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => {
    refresh();
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      // Defer auth operations until Supabase releases its callback lock.
      setTimeout(() => refresh(), 0);
    });
    return () => subscription.unsubscribe();
  }, [refresh]);
  const logout = async () => { await supabase.auth.signOut(); setUser(null); };
  return <AuthContext.Provider value={{user, loading, refresh, logout}}>{children}</AuthContext.Provider>;
};
export const useAuth = () => useContext(AuthContext);
